import { fetchSelfServiceCreditDetail } from '@/api/apiService';
import { Nullable } from '@/types/common';
import { CreditFilter, CreditItem } from '@/types/components';
import { convertTimestampToYYMMDDW, convertTimestampToTime } from '@/utils/convertTimestamp.js';

export const useCreditList = () => {
  const CREDIT_TYPE_FILTERS = [
    { value: 'ALL', label: 'label_all' },
    { value: 'USAGE', label: 'label_use' },
    { value: 'CHARGE', label: 'ss_invoice_type_topup' },
    { value: 'CANCEL', label: 'label_cancel' },
  ];

  const creditList = ref<CreditItem[]>([]);
  const searchType = ref<CreditFilter | null>(null);
  const pagination = ref({
    hasMore: false,
    nextOffset: null,
  });

  const setSearchType = (type) => {
    searchType.value = type;

    fetchCreditList();
  };

  const fetchCreditList = async (offset?: Nullable<string>) => {
    try {
      const type = searchType.value && searchType.value !== 'ALL' ? searchType.value : null;

      const { data } = await fetchSelfServiceCreditDetail(offset, type);

      if (!data || data.datas.length === 0) {
        creditList.value = [];
        pagination.value = {
          hasMore: false,
          nextOffset: null,
        };

        return;
      }

      pagination.value = {
        hasMore: data.hasMore,
        nextOffset: data.nextOffset,
      };

      const list = offset ? creditList.value : [];

      const formattedList = data.datas.reduce((acc, item) => {
        const dateKey = convertTimestampToYYMMDDW(item.eventedAt);
        const existingGroup = acc.find((group) => group.date === dateKey);

        const formatItem = {
          ...item,
          creditSign: item.type === 'USAGE' ? '-' : '+',
          displayType: item.type === 'USAGE' ? 'label_use' : 'ss_history_topup',
          displayTime: convertTimestampToTime(item.eventedAt),
        };

        if (existingGroup) {
          existingGroup.items.push(formatItem);
        } else {
          acc.push({ date: dateKey, items: [formatItem] });
        }

        return acc;
      }, list);

      creditList.value = formattedList;
    } catch (error) {
      console.error('크레딧 내역 조회 실패: ', error);
    }
  };

  return {
    CREDIT_TYPE_FILTERS,
    creditList,
    searchType,
    pagination,
    setSearchType,
    fetchCreditList,
  };
};
